<app-header></app-header>
<div class="container">    
    <div class="row">
        <div class="col-md-6">
            <footer>
                <img class="footer" src="assets/image2.jpg">
            </footer>
        </div>
        <div class="col-md-6 mt-3" style="align-content: space-around;">
            <div class="card">
                <div class="card-header common">
                    Welcome to AHC
                </div>
                <div class="card-body">
                    <div class="home">
                        <button class="btn common mb-3" (click)="routeToCall()">Register</button>
                        <button class="btn common mb-3" (click)="downloadReport()">Download Report</button>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>